import React from 'react';
import QueryDataStore from './store';

const QueryDataContext = React.createContext<QueryDataStore>(QueryDataStore.empty());

export default QueryDataContext;